<template>
<!-- 商品選択 -->
    <b-modal v-model="showFlg"
        size="lg"
        header-bg-variant="light"
        :title="propDesc2+'一覧'" 
        no-close-on-backdrop
        :modal-class="'setHeightCc211'"
        @hide ="handleCancel"
        >
        <b-container>
            <!-- お届け先を選択してください。 -->
            <div>{{propDesc2}}{{$t('cc215.labels.note')}}</div>
            <div class="input-group mb-3 input-group-sm">
                <div class="input-group-prepend">
                    <!-- お名前： -->
                    <span class="input-group-text">{{$t('cc215.labels.name')}}</span>
                </div>
                <input-check class="form-control mutli" v-model="cc215SearchDairiList.tdkName"  maxlength="70"/>
                <div class="input-group-prepend">
                    <!-- 顧客No： -->
                    <span class="input-group-text">{{propDesc1}}</span>
                </div>
                <input-check class="form-control mutli" v-model="cc215SearchDairiList.kokyakuCd"  maxlength="70"/>
            </div>
        </b-container>
        <div class="container">
            <!-- 上記の名前で絞込み -->
            <b-btn size="sm" class="w-4 text-center right" variant="secondary" @click="search();">
                {{$t('cc215.buttons.search')}}
            </b-btn>
        </div>
        <div class="container pt15 clearBoth">
            <data-table v-if="isDisplay"
            :data="urlSearch" 
            :requestSearch ="request215Search"
            :columnsTable="columnsTable"
            :pageID="pageID"
            :maxHeight ="282"
            />
        </div>
        <div slot="modal-footer">
            <b-btn size="sm" class="w-4 text-center btn-sm" variant="secondary" @click="showFlg = false">
                {{$t('common.buttons.close')}}
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import InputCheck from 'components/InputCheck';
import DataTable from "components/Datatable";
import EventBus from 'assets/js/eventBus';
import $ from 'jquery';
export default {
    /* 
    * Name of component
    */
    name: "cc215SearchDairiList",
    /* 
    * Declare components
    */
    components: {
        InputCheck,
        DataTable,
    },
    props:['propDesc1', 'propDesc2', 'propDesc3'],
    /* 
    * Declare variable and set default value
    */
    data() {
        return {
            pageID:'cc215',
            desc1:this.propDesc1,
            desc2:this.propDesc2,
            desc3:this.propDesc3,
            request215Search: {
                descriptionInfo:{}
            },
            descriptionInfo:[],
            columnsTable: [
                {
                    //顧客CD
                    'label': this.propDesc1,
                    'field': 'KOKYAKU_CD',
                    'sort': 'asc&desc',
                    'width': 100,
                    'style': 'text-left',
                    'link': true
                },
                {
                    //お名前
                    'label': this.$i18n.t('sh030.labels.name'),
                    'field': 'TDK_NM_D',
                    'sort': 'asc&desc',
                    'width': 100,
                    'style': 'text-left',
                },
                {
                    //ご住所
                    'label': this.$i18n.t('common.labels.address'),
                    'field': 'ADDRESS_D',
                    'sort': 'asc&desc',
                    'width': 300,
                    'style': 'text-left'
                }
            ],
            urlSearch: this.$UrlConstants.POPUP +this.$UrlConstants.CC215 +this.$UrlConstants.DO_SEARCH,
            pageNo:1,
            pageSize:30,
            isDisplay:false,
            showFlg:true,
            cc215SearchDairiList:{
                tdkName:null
            }
        }
    },
    /* 
    * Initialize
    */
    mounted(){
        var _this = this;
        //Save pageNo and pageSize
        EventBus.$on('page-info', function (pageNo, pageSize) {
            _this.pageNo =  pageNo;
            _this.pageSize = pageSize;
        });
        _this.search();
        //Reload data request model
        EventBus.$on('reset-page', function () {
            _this.request215Search = $.extend({}, _this.cc215SearchDairiList);
        });
       // get data when selected row
        EventBus.$on("cc-select-link", function(value) {
           _this.setValue(value);
        });
    },
    methods:{
        search:function(){
             var _this = this;
            _this.isDisplay = true;
            common.initFlagCC = false;
            _this.request215Search = $.extend({}, _this.cc215SearchDairiList);
            EventBus.$emit("event-dataTable"+_this.pageID, _this.request215Search, undefined, undefined, undefined, 'cc');
        },
        setValue:function(data){
            this.$emit("set-addr-value", data);
            this.showFlg = false;
        },
        /**
         *  Exec close modal
         * @param {Any} evt, event close
         */
        handleCancel(evt){
            evt.preventDefault();
            this.showFlg = false;
        }
    },
    watch: {
        /*
        *  event close modal
        */
       // eslint-disable-next-line
        showFlg(newVal, oldVal) {
            this.$emit('modal-close', 'cc215');
        }
    },
}
</script>